import React, { useEffect, useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './DisplayApp.css';

function DisplayApp() {
  const { projectId } = useParams();
  const [codeSegments, setCodeSegments] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch project code from Firebase
  useEffect(() => {
    const fetchProject = async () => {
      try {
        const docRef = doc(db, 'projects', projectId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const projectData = docSnap.data();
          // Assume projectData.code contains an object with html, css, and js
          setCodeSegments(projectData.code);
        }
      } catch (error) {
        console.error('Error fetching project:', error);
      }
      setIsLoading(false);
    };

    if (projectId) {
      fetchProject();
    } else {
      setIsLoading(false);
    }
  }, [projectId]);

  const renderSrc = useMemo(() => {
    if (codeSegments && (codeSegments.html || codeSegments.css || codeSegments.js)) {
      let cssURL = '';
      if (codeSegments.css) {
        const cssBlob = new Blob([codeSegments.css], { type: 'text/css' });
        cssURL = URL.createObjectURL(cssBlob);
      }
      const jsContent = codeSegments.js ? `<script>${codeSegments.js}</script>` : '';
      const htmlContent = `
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8">
            <title>Project Preview</title>
            ${cssURL ? `<link rel="stylesheet" href="${cssURL}">` : ''}
          </head>
          <body>
            ${codeSegments.html || ''}
            ${jsContent}
          </body>
        </html>
      `;
      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      return URL.createObjectURL(htmlBlob);
    }
    return null;
  }, [codeSegments]);

  if (isLoading) {
    return <div className="display-app">Loading...</div>;
  }

  if (!renderSrc) {
    return <div className="display-app">No code available for this project.</div>;
  }

  return (
    <div className="display-app">
      <iframe
        src={renderSrc}
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Project Display"
      />
    </div>
  );
}

export default DisplayApp;
